import React from 'react'

const WarningIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="warningGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 200, 80, 1)" />
          <stop offset="100%" stopColor="rgba(240, 160, 40, 1)" />
        </linearGradient>
        <filter id="warningGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Triangle */}
      <path 
        d="M12 2L2 20h20L12 2z"
        stroke="url(#warningGradient)"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
        filter="url(#warningGlow)"
      />
      
      {/* Exclamation line */}
      <line 
        x1="12" 
        y1="9" 
        x2="12" 
        y2="14" 
        stroke="url(#warningGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      
      {/* Exclamation dot */}
      <circle 
        cx="12" 
        cy="17" 
        r="1" 
        fill="url(#warningGradient)"
      />
    </svg>
  )
}

export default WarningIcon
